import { type FC } from 'react'

import {
  productAccessorIsSellerPromotionWithVoucherCode,
  ProductSellerPromotionFlag,
} from '../../../../product'
import { productSearchAlgoliaAccessorGetBestOfferSellerPromotion } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetBestOfferSellerPromotion'
import { ProductSearchFlag } from '../../ProductSearchFlag'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

import { ProductSearchItemOfferDiscountFlag } from './ProductSearchItemOfferDiscountFlag'

export const ProductSearchResultItemSellerPromotionLabel: FC = () => {
  const { algoliaRecord } = useProductSearchResultItemContext()

  const sellerPromotion =
    productSearchAlgoliaAccessorGetBestOfferSellerPromotion(algoliaRecord)

  if (!sellerPromotion) {
    return null
  }

  if (productAccessorIsSellerPromotionWithVoucherCode(sellerPromotion)) {
    return (
      <ProductSearchItemOfferDiscountFlag sellerPromotion={sellerPromotion} />
    )
  }

  return (
    <ProductSearchFlag
      className="bg-light-tertiary"
      data-qa-id="serp-has-best-offer-seller-promotion-label"
    >
      <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
    </ProductSearchFlag>
  )
}
